import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import ChatSendingPopup from "../Components/Forms/common/ChatSendingPopup";

import { FirmUserChatContext, hasChatUserId } from "./FirmUserChatContext";

export default function FirmUserChatProvider({ children }) {
  const [recipient, setRecipient] = useState(null);
  const { pathname } = useLocation();
  const closeChat = useCallback(() => setRecipient(null), []);
  const openChat = useCallback((user) => {
    if (hasChatUserId(user.userId)) setRecipient(user);
  }, []);

  useEffect(() => {
    closeChat();
  }, [pathname, closeChat]);

  return (
    <FirmUserChatContext.Provider value={openChat}>
      {children}
      {recipient && (
        <ChatSendingPopup key={recipient.userId} {...recipient} show handleClose={closeChat} />
      )}
    </FirmUserChatContext.Provider>
  );
}
